// Aggregate job catalogue. 4 Tier structure per ADR 0005:
//   Tier 1 = 6 origin jobs, Tier 2 = 11 (default 6 + special 5),
//   Tier 3 = 22 (escalator 6 + cross 16), Tier 4 = 5 legendary.
// Total = 44 jobs. See docs/03-jobs-skills §3.4.
import { JOBS_TIER1 } from './tier1.js';
import { JOBS_TIER2 } from './tier2.js';
import { JOBS_TIER3 } from './tier3.js';
import { JOBS_TIER4 } from './tier4.js';
import { withMvpJobUnlock } from './unlocks.js';
export const JOBS_BY_TIER = {
    1: JOBS_TIER1.map(withMvpJobUnlock),
    2: JOBS_TIER2.map(withMvpJobUnlock),
    3: JOBS_TIER3.map(withMvpJobUnlock),
    4: JOBS_TIER4.map(withMvpJobUnlock),
};
export const ALL_JOBS = [
    ...JOBS_BY_TIER[1],
    ...JOBS_BY_TIER[2],
    ...JOBS_BY_TIER[3],
    ...JOBS_BY_TIER[4],
];
export const JOBS_BY_ID = new Map(ALL_JOBS.map((job) => [job.id, job]));
//# sourceMappingURL=catalogue.js.map